import script from "./SwitchGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchGroup.vue?vue&type=script&setup=true&lang=js"

import "./SwitchGroup.vue?vue&type=style&index=0&id=66bbe70c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bbe70c"]])

export default __exports__